import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../../src/helpers/reselectHelpers';
import {CollapsedItemKeyPrefixesEnum} from '../../../../../../../../src/models/api/localPreferencesModel';
import {getAllRunningSyncCardsJobs} from '../../../../../../../../src/store/data/jobs/jobsSelectors';
import {toggleExpandItemAction} from '../../../../../../../../src/store/data/localPreferences/localPreferencesActions';
import {getFindIsExpanded} from '../../../../../../../../src/store/data/localPreferences/localPreferencesSelectors';
import {getHasCrmSyncFullPageSalesforce} from '../../../../../../../../src/store/featureFlags/featureFlagsSelectors';
import {makeGetSelectedCardIds} from '../../../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {navigateToLinkAction} from '../../../../../../../../src/store/stateless/navigationActions';
import {CompanyContactsPage} from './companyContactsPage';

/*
 * Constants.
 */

const infoBoxExpandedKey = `${CollapsedItemKeyPrefixesEnum.COMPANY_CONTACTS}infoBox`;
const isInfoBoxExpandedDefault = true;

/*
 * Selectors.
 */

const getIsInfoBoxExpanded = createSelector(getFindIsExpanded, (findIsExpanded) =>
  findIsExpanded(infoBoxExpandedKey, isInfoBoxExpandedDefault),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isInfoBoxExpanded: getIsInfoBoxExpanded,
  selectedCardIds: makeGetSelectedCardIds(),
  hasCrmSyncFullPageSalesforce: getHasCrmSyncFullPageSalesforce,
  activeSyncJobs: getAllRunningSyncCardsJobs,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onToggleInfoBox: () => toggleExpandItemAction(infoBoxExpandedKey, isInfoBoxExpandedDefault),
  navigateToLink: navigateToLinkAction,
}));

export const CompanyContactsPageContainer = connect(mapStateToProps, mapDispatchToProps)(CompanyContactsPage);
